export const NOTIFICATION_AUTOCLOSE = 3000;
export const NOTIFICATION_LONG_AUTOCLOSE = 6000;
